import { FeedRoutes } from './feed';
import { EmployeeRoutes } from './registers';

// ==============================|| MENU ITEMS ||============================== //

export const MenuItems = {
  items: [
    FeedRoutes,
    EmployeeRoutes
    // AuxiliaryRoutes
  ]
};
